export default "__VITE_ASSET__Dkfe99ds__"